/**
 * HeroBanner Component - Eye-catching hero section for the homepage
 */

import {
  Box,
  Column,
  Columns,
  ContentBlock,
  Inline,
  Stack,
} from 'braid-design-system';
import type React from 'react';

import { ButtonLink } from '../ButtonLink/ButtonLink';

import * as styles from './HeroBanner.css';

interface HeroBannerProps {
  title?: string;
  subtitle?: string;
  ctaText?: string;
  ctaLink?: string;
}

export const HeroBanner: React.FC<HeroBannerProps> = ({
  title = 'Welcome to the Fae Forest',
  subtitle = 'Step into the world of enchantment with our range of handcrafted fairy garden accessories and characters.',
  ctaText = 'Explore the collection',
  ctaLink = '/products',
}) => (
  <ContentBlock width="large">
    <Box paddingY="large">
      <Columns
        space="xlarge"
        alignY="center"
        align="center"
        collapseBelow="tablet"
        reverse
      >
        <Column>
          <Box className={styles.heroImage} />
        </Column>
        <Column>
          <Stack space="none" align={{ mobile: 'center', tablet: 'left' }}>
            <h1 className={styles.title}>
              Welcome to the
              <br />
              Fae Forest
            </h1>
            <p className={styles.subtitle}>{subtitle}</p>
            <Inline space="none">
              <ButtonLink href={ctaLink}>{ctaText}</ButtonLink>
            </Inline>
          </Stack>
        </Column>
      </Columns>
    </Box>
  </ContentBlock>
);
